/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext } from 'react'

import DittoContext from '../store/context'
import { DittoIssuesManagementClient } from '../store/types'

/** Provides the management issues client instance */
const useDittoClient = (): DittoIssuesManagementClient => {
  const { client } = useContext(DittoContext)

  return client!
}

export default useDittoClient
